import { render, staticRenderFns } from "./user-search.vue?vue&type=template&id=33560179&scoped=true"
import script from "./user-search.vue?vue&type=script&lang=js"
export * from "./user-search.vue?vue&type=script&lang=js"
import style0 from "./user-search.vue?vue&type=style&index=0&id=33560179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33560179",
  null
  
)

export default component.exports